document.addEventListener("DOMContentLoaded", () => { 
  if (!customElements.get('product-slider')) {
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
        this.swiperPrev = null;
        this.swiperNext = null;
        this.swiperPagination = null;
        this.swiperContainer = null;
        this.swiperScrollbar = null;
        this.slideshowSwiper = null;
      }
  
      connectedCallback() {
        this.swiperPrev = this.querySelector('.swiper-button-prev');
        this.swiperNext = this.querySelector('.swiper-button-next');
        this.swiperContainer = this.querySelector('.swiper-container');
        this.swiperPagination = this.querySelector('.swiper-pagination');
        this.slideItems = this.querySelectorAll('.swiper-slide');
  
        if (this.swiperContainer) {
          this.initSwiper();
        }
      }
  
      initSwiper() {
        const autoplay = this.getAttribute('data-autoplay') === 'true';
        const loop = this.getAttribute('loop')=== 'true' ? true : false;
        const autoplayDelay = Number(this.getAttribute('data-autoplay-delay')) || 3000;
  
        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: loop,
          observer: true,
          observeParents: true,
        };

        if (this.swiperNext && this.swiperPrev) {
          swiperOptions.navigation = {
            nextEl: this.swiperNext,
            prevEl: this.swiperPrev,
          };
        }

        if (this.swiperPagination) {
          swiperOptions.pagination = {
            el: this.swiperPagination,
            clickable: true,
          };
        }
  
        if (autoplay) {
          swiperOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }
  
        this.slideshowSwiper = new Swiper(this.swiperContainer, swiperOptions);
      }
  
    }
  
    customElements.define('product-slider', ProductSlider);
  }

  // Countdown
  let localeZone = new Date().getTimezoneOffset() / -60;
  let temp = (localeZone - 2) * 60 * 60 * 1000;

  function showtime(element) {
    const countdownTime = element.dataset.countdownTime;
    let nowtime = new Date(),
      endtime = new Date(countdownTime);

    let milliseconds = endtime.getTime() - nowtime.getTime() < 0 ? 0 : endtime.getTime() - nowtime.getTime() + temp,
      days = String(Math.floor(milliseconds / (1000 * 60 * 60 * 24))).padStart(2, '0'),
      hours = String(Math.floor((milliseconds / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
      minutes = String(Math.floor((milliseconds / (1000 * 60)) % 60)).padStart(2, '0'),
      seconds = String(Math.floor((milliseconds / 1000) % 60)).padStart(2, '0');

    const daysElement = element.querySelector('.countdown-container .days span');
    const hoursElement = element.querySelector('.countdown-container .hours span');
    const minutesElement = element.querySelector('.countdown-container .minutes span');
    const secondsElement = element.querySelector('.countdown-container .seconds span');

    if (daysElement) daysElement.textContent = days;
    if (hoursElement) hoursElement.textContent = hours;
    if (minutesElement) minutesElement.textContent = minutes;
    if (secondsElement) secondsElement.textContent = seconds;
  }

  setInterval(function () {
    const countdownElements = document.querySelectorAll('.section-product-slider .common-countdown-box');
    countdownElements.forEach(function (element) {
      showtime(element);
    });
  }, 1000);
})